import React, { useCallback } from 'react';

import {
	AgentConversationStarters,
	type AgentConversationStartersProps,
	type ConversationStarter,
} from '@atlaskit/rovo-agent-components/ui/AgentConversationStarters';
import { type InteractionSource } from '@atlassian/conversation-assistant-instrumentation/constants/analytics';
import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation/controllers/analytics';

type AgentConversationStartersWithAnalyticsProps = Omit<
	AgentConversationStartersProps,
	'isAgentDefault'
> & {
	interactionSource: InteractionSource;
	isAgentDefault: boolean;
	refreshDesignEnabled?: boolean;
};

export const AgentConversationStartersWithAnalytics = ({
	interactionSource,
	onConversationStarterClick,
	userDefinedConversationStarters,
	isAgentDefault,
	refreshDesignEnabled = false,
}: AgentConversationStartersWithAnalyticsProps): React.JSX.Element => {
	const { sendAnalyticsEvent } = useAnalytics();

	const onClick = useCallback(
		(conversationStarter: ConversationStarter) => {
			sendAnalyticsEvent({
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId: interactionSource,
				attributes: {
					conversationStarterType: conversationStarter.type,
				},
			});

			onConversationStarterClick(conversationStarter);
		},
		[interactionSource, onConversationStarterClick, sendAnalyticsEvent],
	);

	return (
		<AgentConversationStarters
			refreshDesignEnabled={refreshDesignEnabled}
			isAgentDefault={isAgentDefault}
			userDefinedConversationStarters={userDefinedConversationStarters}
			onConversationStarterClick={onClick}
		/>
	);
};
